<main @fade>
  <nb-card>

    <nb-card-header>
      <h4>{{ title }}</h4>
    </nb-card-header>

    <nb-card-header>
      <app-list-actions [list]="this"/>
    </nb-card-header>

    <nb-card-body>
      <ngx-table [nbSpinner]="loading"
        #table
        [configuration]="configuration"
        [data]="data | async"
        [columns]="columns"
        [pagination]="pagination"
        (event)="eventEmitted($event)"
      >
      </ngx-table>

      <ng-template #relationTpl let-row let-rowIndex="rowIndex" let-column="column">
        <ng-container *ngIf="row[column.key]">
          <span *ngIf="row[column.key].length === undefined">{{ row[column.key][multipleElementTemplate[column.key]] }}</span>

          <div i18n="@@Deleted" *ngIf="row[column.key].deleted !== undefined && row[column.key].deleted=== true" class="badge text-bg-secondary" style="clear: both">удален</div>

          <span class="relationTpl" *ngIf="row[column.key].length>0">
                <ng-container *ngFor="let listItem of row[column.key]">
                    <span class="badge">{{ listItem[multipleElementTemplate[column.key]] }}<span i18n="@@MinusDeleted" *ngIf="listItem.deleted !== undefined && listItem.deleted=== true">-удален</span></span>
                </ng-container>
          </span>
        </ng-container>
      </ng-template>

      <ng-template #actionTpl let-row let-rowIndex="rowIndex">
        <div i18n="@@RecordDeleted" *ngIf="row.deleted" class="badge text-bg-secondary" style="clear: both">запись удалена</div>
        <div class="editButtons">
          <button type="button" *ngIf="editCondition(row)&&uriView===uri" i18n-title="@@Edit" [routerLink]="['edit/', row.id]" title="редактировать" nbButton status="control">
            <nb-icon icon="edit-outline"></nb-icon>
          </button>
          <a *ngIf="editCondition(row)&&uriView!==uri" i18n-title="@@Edit" href="{{uriView}}{{row.id}}" title="редактировать" nbButton status="control">
            <nb-icon icon="edit-outline"></nb-icon>
          </a>
          <button type="button" *ngIf="row.deleted !== true && deleteCondition(row)" i18n-title="@@Delete" (click)="onDeleteConfirm(row.id)" title="удалить" nbButton status="control">
            <nb-icon icon="close"></nb-icon>
          </button>
        </div>
      </ng-template>

      <ng-template #headerTpl let-row>
        <a *ngIf="editCondition(row)&&uriView!==uri" href="{{uriView}}{{row.id}}">{{ row.header }}</a>
        <a *ngIf="editCondition(row)&&uriView===uri" [routerLink]="['edit/', row.id]">{{ row.header }}</a>
        <ng-container *ngIf="!editCondition(row)">{{ row.header }}</ng-container>
      </ng-template>

      <ng-template #previewVideoTpl let-row>
        <a [href]="row.link" target="_blank">
          <img [src]="getYouTubeVideoSrc(row)" alt="">
        </a>
      </ng-template>
    </nb-card-body>
  </nb-card>
</main>
